// src/common/ToastProvider.js
import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const showToast = (
  message,
  type = "info",
  duration = 5000,
  position = "top-center" // 🔥 default top-center
) => {
  const options = {
    position,
    autoClose: duration,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    theme: "colored",
  };

  switch (type) {
    case "success":
      toast.success(message, options);
      break;
    case "error":
      toast.error(message, options);
      break;
    case "warn":
      toast.warn(message, options);
      break;
    default:
      toast.info(message, options);
      break;
  }
};



// 🔹 Auto logout helper
export const autoLogout = (callback = null) => {
  setTimeout(() => {
    fetch(`${process.env.REACT_APP_API_URL}/logout.php`, {
      method: "POST",
      credentials: "include",
    }).then(() => {
      if (callback) {
        callback(); // e.g. redirect to track page
      } else {
        window.location.href = "/"; // default back to home
      }
    });
  }, 10000); // 10 seconds
};

const ToastProvider = () => {
  return <ToastContainer />;
};

export default ToastProvider;
